<div fxLayout="row wrap">
  <p  class="m-0 mr-12 w-100 font-weight-600 font-size-14"
      style="margin: auto 12px auto 0px !important"> {{ 'dttable.office_filters' | translate }} </p>
          <div fxLayout="row wrap">
              <div *ngFor="let officeFilter of officeFilters">
                  <button class="m-4 happ-small-button happ-button-list happ-button font-size-14"
                  mat-raised-button (click)="buttonClicked(officeFilter)" [color]="(selectedOfficeFilter === officeFilter.name) ? 'primary' : ''" > {{ officeFilter.name }} </button>
              </div>
          </div>
</div>